import { Injectable } from '@angular/core';

@Injectable()
export class SimpleQueryResponse<T> {

  public pageNumber: number;
  public pageSize: number;
  public count: number;
  public objets: T[];
}
